// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef } from 'react';
import {
  RocketlaneUIControl,
  AsyncCreatableSelect as BaseAsyncCreatableSelect,
} from 'components/atoms/select';
import {
  CreatableSelect as BaseCreatableSelect,
  CreatableSelectProps,
} from 'components/atoms/select/creatable';
import { ClassNameOnlyProps } from 'components/ozone-component';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';
import { createNewDesignStyles, NEW_DESIGN_STYLES } from './select';

const RocketUICreatableSelect = forwardRef<
  any,
  React.PropsWithChildren<CreatableSelectProps & ClassNameOnlyProps>
>(({ components = {}, styles, ...props }, ref) => {
  const computedStyles = createNewDesignStyles(NEW_DESIGN_STYLES, styles || {});

  return (
    <BaseCreatableSelect
      {...props}
      components={{
        Control: RocketlaneUIControl,
        ...components,
      }}
      styles={computedStyles}
      ref={ref}
    />
  );
});

const RocketUIAsyncCreatableSelect = forwardRef<
  any,
  React.PropsWithChildren<CreatableSelectProps & ClassNameOnlyProps>
>(({ components = {}, styles, ...props }, ref) => {
  const computedStyles = createNewDesignStyles(NEW_DESIGN_STYLES, styles || {});

  return (
    <BaseAsyncCreatableSelect
      {...props}
      components={{
        Control: RocketlaneUIControl,
        ...components,
      }}
      styles={computedStyles}
      ref={ref}
    />
  );
});

export const CreatableSelect = forwardRef<
  any,
  React.PropsWithChildren<CreatableSelectProps & ClassNameOnlyProps>
>((props, ref) => {
  const isNewDesignEnabled = useAntdRlUISwitcher();

  if (isNewDesignEnabled) {
    return <RocketUICreatableSelect {...props} ref={ref} />;
  }

  return <BaseCreatableSelect {...props} ref={ref} />;
});

export const AsyncCreatableSelect = forwardRef<
  any,
  React.PropsWithChildren<CreatableSelectProps & ClassNameOnlyProps>
>((props, ref) => {
  const isNewDesignEnabled = useAntdRlUISwitcher();

  if (isNewDesignEnabled) {
    return <RocketUIAsyncCreatableSelect {...props} ref={ref} />;
  }

  return <BaseAsyncCreatableSelect {...props} ref={ref} />;
});

CreatableSelect.displayName = 'CreatableSelect';
